import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  avatarContainer: {
    position: "relative",
    width: 100,
    height: 100,
  },
  avatarStyle: {
    width: 100,
    height: 100,
    boxShadow: "0px 0px 8px 8px #B5B5B517",
  },
  avatarEmpty: {
    width: 100,
    height: 100,
    backgroundColor: "#BDBDBD",
    boxShadow: "0px 0px 8px 8px #B5B5B517",
    "& img": {
      objectFit: "cover",
      width: 42,
      height: 42,
    },
  },
  editButton: {
    position: "absolute",
    bottom: "0",
    right: "0",
    backgroundColor: "#00a1ed",
    padding: "11px",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  menuPaper: {
    minWidth: "220px",
    marginTop: "7px",
    border: 0,
  },
  dialog: {
    ".MuiPaper-root": {
      backgroundColor: "transparent",
      boxShadow: "none",
      overflow: "visible",
      margin: 0,
      background: "transparent",
      width: "100%",
      padding: 0,
    },
  },
  dialogContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    background: "transparent",
    padding: 0,
    border: 0,
  },
};
